import type { ComponentProps } from 'react';
import { FieldInfo, hasFieldError, useFieldContext, useIsFieldOptional } from './shared';
import { FieldLabelRow } from './field-label-row';
import { Input } from '../input';
import { formatDatetime } from '../../lib/utils';

export default function DateTimeField({ label, className, ...props }: ComponentProps<'input'> & { label: string }) {
	const field = useFieldContext<string | null | undefined>();
	const isOptional = useIsFieldOptional(field.name);

	return (
		<div className={className}>
			<div className="grid gap-2">
				{label && (
					<FieldLabelRow
						label={label}
						htmlFor={field.name}
						hasError={field.state.meta.isTouched && !field.state.meta.isValid}
						optional={isOptional}
					/>
				)}
				<Input
					type="datetime-local"
					id={field.name}
					name={field.name}
					aria-invalid={hasFieldError(field.state.meta)}
					value={field.state.value ? formatDatetime(field.state.value) : ''}
					onBlur={field.handleBlur}
					onChange={(e) => field.handleChange(e.target.value ? new Date(e.target.value).toISOString() : null)}
					{...props}
				/>
			</div>
			<FieldInfo fieldState={field.state} />
		</div>
	);
}
